namespace Areas.Analysis.DrawingHistory {
    "use strict";

    export function goToProjectFromGrid(e: any) {
        const dataGrid = $("#DrawingHistoryGrid").dxDataGrid("instance");
        const rows = dataGrid.getSelectedRowsData();
        if (rows.length == 1) {
            location.href = "/Project/Profile/View/" + rows[0].projectId;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }

    }

}